import * as tslib_1 from "tslib";
import { ViewContainerRef } from '@angular/core';
import { LayerApi } from '../../../api/layer-api';
import { UserApi } from '../../../api/user-api';
import { environment } from '../../../environment';
import { LayerService } from '../../../services/layer.service';
import { LayerCatalogService } from '../../../services/layerCatalog.service';
import { LayerTypeId } from '../../../types';
import { BaseComponent } from '../../base.component';
var SaveLayerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SaveLayerComponent, _super);
    function SaveLayerComponent(authService, layerService, layerCatalogService, layerApi, userApi, _vcr) {
        var _this = _super.call(this, _vcr) || this;
        _this.authService = authService;
        _this.layerService = layerService;
        _this.layerCatalogService = layerCatalogService;
        _this.layerApi = layerApi;
        _this.userApi = userApi;
        _this.enableFolders = false;
        _this.userId = null;
        _this.createNewFolder = false;
        _this.newFolder = null;
        _this.parentFolders = [];
        _this.parentFolderId = 0;
        _this.appId = environment.appId;
        _this.createNewLayer = true;
        _this.disableCreateLayer = true;
        _this.isLoading = false;
        _this.getClosestAncestor('mc-window').then(function (window) {
            if (window) {
                _this.windowRef = window;
                _this.windowRef.addEventListener('openChange', function (open) {
                    if (open.detail) { // detail is value prop sent by angular event
                        _this.windowOpened();
                    }
                    else {
                        _this.windowClosed();
                    }
                });
            }
            else {
                _this.windowOpened();
            }
        });
        return _this;
    }
    SaveLayerComponent.prototype.windowOpened = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, e_2, _b, _c, _d, layers, _e, isLayerOwner, canUpdateLayer, userLayers, userLayerIds, userLayerFolders, existingLayersFolderId, userLayerFolders_1, userLayerFolders_1_1, folder, _f, _g, layer;
            var _this = this;
            return tslib_1.__generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        this.isLoading = true;
                        this.createNewLayer = true;
                        this.disableCreateLayer = true;
                        if (!!this.userSubscriber) return [3 /*break*/, 2];
                        _c = this;
                        return [4 /*yield*/, this.authService.GetCurrentUser().subscribe(function (user) {
                                if (user && user.id) {
                                    _this.userId = user.id;
                                }
                                else {
                                    _this.userId = null;
                                }
                            })];
                    case 1:
                        _c.userSubscriber = _h.sent();
                        _h.label = 2;
                    case 2:
                        this.esriLayer = this.layerService.getEsriLayerByUniqueId(this.layerId);
                        this.name = this.esriLayer.mapcoreProps.name;
                        this.description = this.esriLayer.mapcoreProps.description;
                        this.layerType = this.esriLayer.type === 'graphics' ? 'drawing-layers' : 'layers';
                        _d = this;
                        return [4 /*yield*/, this.userApi.queryUserFolders(this.userId, environment.appId, this.layerType)];
                    case 3:
                        _d.parentFolders = (_h.sent());
                        this.parentFolders = this.parentFolders.sort(function (a, b) { return a.name.toLowerCase().localeCompare(b.name.toLowerCase()); });
                        this.parentFolders.unshift({ name: 'No parent folder', id: 0 });
                        if (!this.esriLayer.mapcoreProps.idFromSavedLayer) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.layerApi.getUserLayers(this.esriLayer.mapcoreProps.idFromSavedLayer)];
                    case 4:
                        _e = _h.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        _e = [];
                        _h.label = 6;
                    case 6:
                        layers = _e;
                        isLayerOwner = layers && layers[0] && this.isUserOwnerOfLayer(layers[0]);
                        canUpdateLayer = this.esriLayer.mapcoreProps.typeId !== LayerTypeId.Map && isLayerOwner;
                        if (canUpdateLayer) {
                            this.createNewLayer = false;
                            this.disableCreateLayer = false;
                        }
                        else {
                            this.name = this.name + ' - Copy';
                        }
                        return [4 /*yield*/, this.layerCatalogService.getUserLayerCatalog(this.userId)];
                    case 7:
                        userLayers = _h.sent();
                        userLayerIds = userLayers.map(function (x) { return x.layer.id; });
                        if (!userLayerIds.includes(this.esriLayer.mapcoreProps.idFromSavedLayer)) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.layerService.getUserLayersFolders(this.userId, environment.appId)];
                    case 8:
                        userLayerFolders = (_h.sent())[0].folders;
                        existingLayersFolderId = 0;
                        try {
                            for (userLayerFolders_1 = tslib_1.__values(userLayerFolders), userLayerFolders_1_1 = userLayerFolders_1.next(); !userLayerFolders_1_1.done; userLayerFolders_1_1 = userLayerFolders_1.next()) {
                                folder = userLayerFolders_1_1.value;
                                try {
                                    for (_f = tslib_1.__values(folder.layers), _g = _f.next(); !_g.done; _g = _f.next()) {
                                        layer = _g.value;
                                        if (layer.id === this.esriLayer.mapcoreProps.idFromSavedLayer) {
                                            existingLayersFolderId = folder.id;
                                            break;
                                        }
                                    }
                                }
                                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                finally {
                                    try {
                                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                                    }
                                    finally { if (e_2) throw e_2.error; }
                                }
                                if (existingLayersFolderId !== 0) {
                                    break;
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (userLayerFolders_1_1 && !userLayerFolders_1_1.done && (_a = userLayerFolders_1.return)) _a.call(userLayerFolders_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.parentFolderId = existingLayersFolderId;
                        _h.label = 9;
                    case 9:
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    SaveLayerComponent.prototype.closeWindow = function () {
        this.windowRef.close();
    };
    SaveLayerComponent.prototype.isNewFolder = function () {
        this.createNewFolder = this.createNewFolder ? false : true;
        if (this.createNewFolder) {
            this.newFolder = { name: '', parentUserFolderId: null, userId: this.userId, applicationId: environment.appId, category: this.layerType };
        }
        else {
            this.newFolder = undefined;
        }
    };
    SaveLayerComponent.prototype.parentFolderSelected = function (value) {
        if (this.createNewFolder) {
            this.newFolder.parentUserFolderId = value;
        }
        else {
            this.esriLayer.mapcoreProps.parentId = value;
        }
    };
    SaveLayerComponent.prototype.saveLayer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var layer, createdFolder, newLayerId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        layer = this.layerService.getLayerForSave(this.esriLayer, this.name, this.description, LayerTypeId.User, this.createNewLayer, false);
                        if (!(layer && this.userId)) return [3 /*break*/, 6];
                        if (!this.createNewFolder) return [3 /*break*/, 2];
                        this.newFolder.parentUserFolderId = this.parentFolderId;
                        return [4 /*yield*/, this.userApi.createNewUserFolder(this.newFolder)];
                    case 1:
                        createdFolder = _a.sent();
                        this.parentFolderId = createdFolder.id;
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.layerApi.saveLayer(layer, this.userId)];
                    case 3:
                        newLayerId = _a.sent();
                        if (this.createNewLayer) {
                            this.esriLayer.mapcoreProps.idFromSavedLayer = newLayerId;
                        }
                        this.esriLayer.mapcoreProps.name = this.name;
                        this.esriLayer.mapcoreProps.description = this.description;
                        if (!this.parentFolderId) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.layerService.saveLayerToUserFolder(newLayerId, this.parentFolderId)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        this.layerService.layersRefreshed.emit();
                        _a.label = 6;
                    case 6:
                        this.closeWindow();
                        return [2 /*return*/];
                }
            });
        });
    };
    SaveLayerComponent.prototype.windowClosed = function () {
        this.esriLayer = null;
        this.createNewFolder = false;
        this.newFolder = undefined;
        this.parentFolders = [];
    };
    SaveLayerComponent.prototype.isUserOwnerOfLayer = function (layer) {
        if (layer.userLayers) {
            var ownerIndex = layer.userLayers.findIndex(function (m) { return m.accessLevel === 'OWNER'; });
            if (layer.userLayers[ownerIndex] && layer.userLayers[ownerIndex].userId === this.userId) {
                return true;
            }
        }
        return false;
    };
    SaveLayerComponent.prototype.folderTrack = function (_index, item) {
        return item.id;
    };
    return SaveLayerComponent;
}(BaseComponent));
export { SaveLayerComponent };
